import { Reveal } from '@/components/motion/Reveal';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const testimonials = [
  {
    quote:
      'We feed 400 campers every session, and CampChef Pro saved us more than 40 hours per week in planning and ordering time. I can\'t imagine going back.',
    author: 'Sarah Johnson',
    role: 'Director',
    organization: 'Pine Ridge Summer Camp',
    location: 'North Carolina',
  },
  {
    quote:
      'Sysco orders are generated automatically now — no spreadsheets, no late-night math. Our volunteers love how easy it is.',
    author: 'Mike Chen',
    role: 'Kitchen Manager',
    organization: 'The Summit California',
    location: 'California',
  },
  {
    quote:
      'We serve diverse dietary needs every weekend, and CampChef Pro keeps it organized. Zero missed meals, zero stress.',
    author: 'Elena Martinez',
    role: 'Retreat Chef',
    organization: 'Horizon Faith Center',
    location: 'Texas',
  },
  {
    quote:
      'CampChef Pro turned our chaos into calm. We finally have a real kitchen system that fits how camps actually work.',
    author: 'Jacob Rivera',
    role: 'Food Service Director',
    organization: 'Camp Evergreen',
    location: 'Oregon',
  },
];

const metrics = [
  { k: '40+', v: 'Hours saved monthly' },
  { k: '99.7%', v: 'Order accuracy' },
  { k: '50K+', v: 'Meals managed daily' },
  { k: '500+', v: 'Camps nationwide' },
];

export const TestimonialsSection = () => {
  return (
    <section className="bg-sand py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <span className="eyebrow">Field reports</span>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-display text-display-md text-midnight-green mt-5 text-balance">
              Camp stories that inspire us.
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-5 max-w-prose font-inter text-base text-slate/70 text-pretty">
              Real kitchens, real teams, real results — from camps across the country.
            </p>
          </Reveal>
        </div>

        {/* Editorial pull-quote grid */}
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-x-14 gap-y-16 border-t border-foreground/10 pt-14">
          {testimonials.map((t, i) => (
            <Reveal key={t.author} delay={i * 80}>
              <figure className="relative">
                <span
                  aria-hidden
                  className="absolute -top-6 -left-2 font-display text-7xl leading-none text-copper/30 select-none"
                >
                  &ldquo;
                </span>
                <blockquote className="font-display text-xl lg:text-2xl text-midnight-green leading-snug text-balance">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-6 flex items-baseline gap-3 font-inter text-sm">
                  <span className="font-semibold text-midnight-green">{t.author}</span>
                  <span className="text-slate/60">— {t.role}, {t.organization}</span>
                </figcaption>
                <div className="mt-1 text-xs uppercase tracking-[0.18em] text-slate/45">{t.location}</div>
              </figure>
            </Reveal>
          ))}
        </div>

        {/* Metrics row */}
        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6 border-t border-foreground/10 pt-12">
          {metrics.map((m, i) => (
            <Reveal key={m.k} delay={i * 70}>
              <div>
                <div className="font-display text-4xl text-copper tabular-nums">{m.k}</div>
                <div className="mt-2 font-inter text-sm text-slate/70">{m.v}</div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Closing nudge */}
        <Reveal delay={120}>
          <div className="mt-20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-foreground/10 pt-12">
            <h3 className="font-display text-2xl lg:text-3xl text-midnight-green text-balance max-w-xl">
              Your camp could be our next story.
            </h3>
            <div className="flex items-center gap-4">
              <Button asChild className="bg-copper hover:bg-copper/90 text-ivory btn-press">
                <Link to="/contact">Request a demo</Link>
              </Button>
              <Link
                to="/pricing"
                className="story-link font-inter text-sm font-medium text-midnight-green/80 hover:text-midnight-green"
              >
                See pricing
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
